exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-marquee {\n  width: 100%;\n  overflow: hidden;\n}\n.vux-marquee-box {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  height: auto;\n}\n.vux-marquee-box li {\n  margin: 0;\n  width: 100%;\n}\n", ""]);

// exports
